import api from '@/api';

export default {
  bannersCountClick: id => api.post('banners/clicks', id),
  bannersList: showAt => api.get('banners', {
    params: {
      showAt,
    },
  }),
};
